module.exports = __webpack_public_path__ + "web-assets/img/bgg.30635bf3.png";